module.exports = __webpack_public_path__ + "c840aec6dfe7ae865a23cce60544c82b.pdf";